import { connection } from '../Config/Settings';

const Pages = ({ params }) =>  {

    // TODO: return null for development only
    // window.open(`${connection().clientUrl}`, '_self');
    //
    // return null

    window.open(`${connection().serverUrl}/pages?id=${ params && params.id}`, '_self');

    return null;
};

export default Pages;



// WEBPACK FOOTER //
// ./src/Pages/Pages.js